import {
    assign,
    boolean,
    literal,
    nullable,
    number,
    string,
    type,
} from "superstruct";

import InstagramBaseLayoutSchema from "./InstagramBaseLayoutSettingsSchema";

const InstagramSlideLayoutSettingsSchema = assign(
    type({
        label: nullable(string()),
        layout: literal("slide"),
        space: number(),
        minItems: nullable(number()),
        visiblePostCountForSlider: nullable(number()),
        visiblePostCountForSliderOnMobile: nullable(number()),
        slideShowEnabled: boolean(),
        sliderCentered: boolean(),
        sliderMoveSize: nullable(number()),
        sliderLoopEnabled: boolean(),
        autoPlayIntervalForSlider: number(),
    }),
    InstagramBaseLayoutSchema
);

export default InstagramSlideLayoutSettingsSchema;
